import dayjs from "dayjs";
import UTC from "dayjs/plugin/utc";
dayjs.extend(UTC);

export const parseTimeToLocal = (str: string | undefined) => {
  if (!str) {
    return "";
  }

  return dayjs
    .utc(str, "YYYY-MM-DD.HH:mm:ss")
    .local()
    .format("YYYY-MM-DD HH:mm");
};

export const parseDateToLocal = (str: string | undefined) => {
  if (!str) {
    return "";
  }

  return dayjs.utc(str, "YYYY-MM-DD").local().format("YYYY-MM-DD");
};
